import type { DecorationAssetFragment } from '@seek/cmsu-cms-connect';
import type React from 'react';

import { useGetDecoratorAssetConfig } from './hooks/useGetDecoratorAssetConfig';

export const BoxDecoratorGroup = ({
  decorators,
}: {
  decorators?: DecorationAssetFragment[];
}) => {
  if (!decorators || decorators.length === 0) {
    return null;
  }

  return decorators.map((decorator, i) => (
    <DecoratorItem key={i} decorator={decorator} />
  ));
};

const DecoratorItem = ({
  decorator,
}: {
  decorator: DecorationAssetFragment;
}) => {
  const decoratorSetting = useGetDecoratorAssetConfig({ decorator });
  const style: React.CSSProperties = {
    width: decoratorSetting.size ?? '100px',
    margin: 'auto',
    position: 'absolute',
  };

  if (decoratorSetting?.top !== null) style.top = decoratorSetting.top;
  if (decoratorSetting?.bottom !== null) style.bottom = decoratorSetting.bottom;
  if (decoratorSetting?.left !== null) style.left = decoratorSetting.left;
  if (decoratorSetting?.right !== null) style.right = decoratorSetting.right;
  if (decoratorSetting?.zIndex !== null) style.zIndex = decoratorSetting.zIndex;

  if (!decorator.image) {
    return null;
  }

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        position: 'absolute',
        overflow: decoratorSetting.overflow ? 'visible' : 'hidden',
      }}
    >
      <img
        src={decorator.image.url}
        style={decoratorSetting.cssOverride ?? style}
      />
    </div>
  );
};
